"use strict";
var _a;
exports.__esModule = true;
exports.EventModuleEnum = exports.ModuleDisplayTypeEnum = exports.FirstOrderablePosition = exports.TempFixedModulePositionEnum = exports.SingleUsePerStageModules = exports.NonListableModules = exports.ModuleEnum = void 0;
var ModuleEnum;
(function (ModuleEnum) {
    ModuleEnum["GreetingHeader"] = "GreetingHeader";
    ModuleEnum["Logistics"] = "Logistics";
    ModuleEnum["Values"] = "Values";
    ModuleEnum["PhoneScreenHeader"] = "PhoneScreenHeader";
    ModuleEnum["Schedule"] = "Schedule";
    ModuleEnum["Mission"] = "Mission";
    ModuleEnum["Time"] = "Time";
    ModuleEnum["Links"] = "Links";
    ModuleEnum["Location"] = "Location";
    ModuleEnum["Expectations"] = "Expectations";
    ModuleEnum["Media"] = "Media";
    ModuleEnum["TeamPhoto"] = "TeamPhoto";
    ModuleEnum["CandidatePostInterviewFeedback"] = "CandidatePostInterviewFeedback";
    ModuleEnum["Chat"] = "Chat";
    ModuleEnum["InterviewScheduler"] = "InterviewScheduler";
    ModuleEnum["InterviewTeam"] = "InterviewTeam";
    ModuleEnum["RichText"] = "RichText";
    ModuleEnum["InterviewProcess"] = "InterviewProcess";
})(ModuleEnum = exports.ModuleEnum || (exports.ModuleEnum = {}));
exports.NonListableModules = [
    ModuleEnum.CandidatePostInterviewFeedback,
    ModuleEnum.Chat,
];
exports.SingleUsePerStageModules = [
    ModuleEnum.GreetingHeader,
    ModuleEnum.Time,
    ModuleEnum.Schedule,
    ModuleEnum.Location,
    ModuleEnum.Mission,
    ModuleEnum.Values,
    ModuleEnum.InterviewTeam,
    ModuleEnum.InterviewScheduler,
    ModuleEnum.InterviewProcess,
];
exports.TempFixedModulePositionEnum = Object.freeze((_a = {},
    _a[ModuleEnum.InterviewProcess] = 0,
    _a[ModuleEnum.GreetingHeader] = 2,
    _a[ModuleEnum.Time] = 3,
    _a[ModuleEnum.Location] = 4,
    _a[ModuleEnum.Schedule] = 5,
    _a[ModuleEnum.RichText] = 6,
    _a[ModuleEnum.InterviewTeam] = 7,
    _a[ModuleEnum.InterviewScheduler] = 8,
    _a[ModuleEnum.Logistics] = 9,
    _a[ModuleEnum.Expectations] = 10,
    _a[ModuleEnum.Media] = 11,
    _a[ModuleEnum.TeamPhoto] = 12,
    _a[ModuleEnum.Mission] = 13,
    _a[ModuleEnum.Values] = 14,
    _a[ModuleEnum.Links] = 15,
    _a[ModuleEnum.Chat] = 98,
    _a[ModuleEnum.CandidatePostInterviewFeedback] = 99,
    _a[ModuleEnum.PhoneScreenHeader] = 999,
    _a));
exports.FirstOrderablePosition = exports.TempFixedModulePositionEnum.RichText;
exports.ModuleDisplayTypeEnum = Object.freeze({
    GreetingHeader: "GreetingHeader",
    InfoChips: "InfoChips",
    InfoCards: "InfoCards",
    Values: "Values",
    RichText: "RichText",
    PhoneScreenHeader: "PhoneScreenHeader",
    Schedule: "Schedule",
    Mission: "Mission",
    Time: "Time",
    Links: "Links",
    Location: "Location",
    Remote: "Remote",
    Media: "Media",
    TeamPhoto: "TeamPhoto",
    CandidatePostInterviewFeedback: "CandidatePostInterviewFeedback",
    Chat: "Chat",
    InterviewScheduler: "InterviewScheduler",
    InterviewTeam: "InterviewTeam",
    InterviewProcess: "InterviewProcess"
});
var EventModuleEnum;
(function (EventModuleEnum) {
    EventModuleEnum["ProminentInstructions"] = "ProminentInstructions";
    EventModuleEnum["CoderPad"] = "CoderPad";
    EventModuleEnum["Zoom"] = "Zoom";
})(EventModuleEnum = exports.EventModuleEnum || (exports.EventModuleEnum = {}));
//# sourceMappingURL=module-enums.js.map